<template>
  <li
    class="LeftNav__Item"
    :class="{
      opened: opened,
      'LeftNav__Item--active': active
    }"
  >
    <a
      :href="url ? url : '#'"
      class="flex items-center text-sm"
      @click="open($event)"
      v-if="!$slots.link"
    >
      <span class="mr-2" @click="open">
        <aw-icon
          :icon="icon"
          class="w-4 h-4"
          :class="{
            '': iconFillCurrent,
            '': !iconFillCurrent
          }"
          v-if="icon"
        ></aw-icon>
        <img :src="img" class="w-4 h-4 mr-3" alt="" v-else-if="img" />
        <span class="w-4" v-else></span>
      </span>
      <span class="flex-grow">{{ title }}</span>
      <span class="mr-2">
        <aw-icon
          icon="chevron-right"
          class="w-4 h-4 "
          v-if="$attrs.id"
        ></aw-icon>
      </span>
    </a>
    <slot v-else name="link" v-bind="{ open }" />
    <ul v-if="$slots.default">
      <teleport :to="'#LeftNavMobileStep' + $attrs.id" v-if="opened">
        <slot />
      </teleport>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'NavItem',
  props: {
    title: String,
    url: String,
    icon: String,
    img: {
      type: String,
      default: null,
      required: false
    },
    iconFillCurrent: {
      type: Boolean,
      default: false,
      required: false,
    },
    presenters: {
      type: Array,
      default: () => {
        return []
      },
      required: false,
    }
  },
  inject: ['addNavStep', 'openNavStep', 'openedNavStepIds'],
  mounted() {
    if (this.$slots.default) {
      this.addNavStep(this.$attrs.id)
    }
  },
  computed: {
    opened() {
      return (
        this.$attrs.id &&
        this.openedNavStepIds.value.indexOf(this.$attrs.id) !== -1
      )
    },
    active() {
      const presenterInfo = this.$store.getters['nette/currentPresenter']
      return this.url === this.$route.path || this.presenters.includes(presenterInfo.name + '.' + presenterInfo.action)
    }
  },
  methods: {
    open(e) {
      if (!this.url && this.$slots.default) {
        e.stopPropagation()
        e.preventDefault()
        this.openNavStep(this.title, this.icon, this.$attrs.id)
      }
    }
  }
}
</script>
